const headRowsUsers = {
  name: 'Nome',
  email: 'E-mail',
  role: 'Tipo de Acesso',
  site: 'Sites',
  lastLogin: 'Último Acesso'
};

export default headRowsUsers;
